<template>
  <div class="py-4 text-center text-premier-blue px-3 mt-2 bg-white" style="min-height: calc(100vh - 75px)">
    <p class="text-uppercase font-24px font-rubik-medium mb-5">
      Pembayaran Berhasil
    </p>
    <p class="font-20px text-soft-grey-netral">
      Jadwal Anda dengan dokter telah dibuat
    </p>
    <div class="row justify-content-center">
      <div class="col-sm-8 col-12">
        <b-card no-body class="overflow-hidden">
          <div v-if="doctorData" class="bg-green text-white p-3">
            <div class="d-flex">
              <img :src="doctorData.Avatar" alt="" width="45px" height="45px" class="rounded-circle border-w2">
              <div class="ml-3 text-left flex-1">
                <p class="mb-0 font-rubik-medium font-18px text-white">
                  {{ doctorData.Fullname }}
                </p>
                <span class="font-16px">{{ doctorData.DoctorTypeLang ? doctorData.DoctorTypeLang.ID : doctorData.DoctorType }}</span>
              </div>
            </div>
          </div>
          <div v-if="selectedAppointment" class="bg-premier-blue text-white p-4 text-left">
            <span class="d-flex align-items-center justify-content-left font-24px font-rubik-medium lh-1 text-white">
              <img src="@/assets/icon/icon-calendar-new.svg" alt="" class="mr-2" width="25px" height="25px">
              {{ $moment.unix(selectedAppointment.Start).format('dddd, DD MMM YYYY') }}
            </span>
            <span class="d-flex align-items-center justify-content-left font-24px font-rubik-medium lh-1 mt-3 text-white">
              <img src="@/assets/icon/icon-clock-circle-new.svg" alt="" class="mr-2" width="25px" height="25px">
              {{ $moment.unix(selectedAppointment.Start).format('HH:mm') }}
              {{ $getLocalTimeZone($moment.unix(selectedAppointment.Start).format('Z')) }} -
              {{ $moment.unix(selectedAppointment.Start + selectedAppointment.ConversationTime).format('HH:mm') }}
              {{ $getLocalTimeZone($moment.unix(selectedAppointment.Start).format('Z')) }}
            </span>
            <span class="d-flex align-items-center justify-content-left font-24px font-rubik-medium lh-1 mt-3 text-white">
              <img src="@/assets/icon/icon-hourglass-line-new.svg" alt="" class="mr-2" width="25px" height="25px">
              {{ selectedAppointment.ConversationTime / 60 }} Menit
            </span>
          </div>
        </b-card>
      </div>
    </div>
    <div class="mb-5">
      <span class="d-flex text-center justify-content-center font-24px font-rubik-medium lh-1 mt-3 text-soft-grey-netral-2">
        Konsultasi hanya dapat dilakukan melalui aplikasi
      </span>
      <span class="d-flex text-left justify-content-left font-18px font-rubik-medium lh-1 mt-5 text-soft-grey-netral-2">
        <img src="@/assets/icon/icon-battery.svg" alt="" class="mr-2" width="45px" height="45px">
        Pastikan baterai handphone Anda tidak dalam keadaan “Power Saving”
      </span>
      <span class="d-flex text-left justify-content-left font-18px font-rubik-medium lh-1 mt-3 text-soft-grey-netral-2">
        <img src="@/assets/icon/icon-signal.svg" alt="" class="mr-2" width="45px" height="45px">
        Pastikan jaringan Anda bagus dan baterai diatas 25% saat berkonsultasi
      </span>
      <span class="d-flex text-left justify-content-left font-18px font-rubik-medium lh-1 mt-3 text-soft-grey-netral-2">
        <img src="@/assets/icon/icon-bell.svg" alt="" class="mr-2" width="45px" height="45px">
        Pastikan Anda selalu menyalakan push notifikasi untuk aplikasi yesdok
      </span>
    </div>
    <div>
      <b-button variant="success-2" class="border-r25px" block size="lg" @click="openYesDokApp">
        Buka YesDok
      </b-button>
      <b-button variant="outline-primary-3" class="border-r25px" block size="lg" @click="openDownloadApp">
        Download YesDok
      </b-button>
    </div>
  </div>
</template>

<script>
import { isAndroid, isIOS } from 'mobile-device-detect'

export default {
  name: 'PaymentSuccess',
  computed: {
    doctorData () {
      return this.$store.state.doctor.doctorData ? this.$store.state.doctor.doctorData.Doctor : null
    },
    selectedAppointment () {
      return this.$store.state.doctor.booking.selectedAppointment
    }
  },
  methods: {
    openDownloadApp () {
      if (process.client) {
        if (isIOS) {
          return window.open('http://ydok.co/ios', '_blank')
        }
        if (isAndroid) {
          return window.open('http://ydok.co/android', '_blank')
        }
        return window.open('http://ydok.co/dw', '_blank')
      }
    },
    openYesDokApp () {
      window.location.href = process.env.CTA_YESDOK_APP
    }
  }
}
</script>

<style lang="scss">
.bg-green {
  // background: #00C300 !important;
  background: #5ECF3F !important;
}
.bg-premier-blue {
  // background: #024668 !important;
  background: #404040 !important;
}
</style>
